/*
 * Copyright (c) 2018 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of 2018 SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name: Greenlight3dView.js
 *
 * Description:   JavaScript code for the 3D view module.
 *
 * History:       24-AUG-18   S Norman      Initial implementation.
 *                16-JAN-19   S Norman      Make sure to use the correct canvas when in compare mode and saving an annotation.
 *                                          Now clears the annotations from the scene after setting up the annotations so that they can be redrawn in the correct positions. (DR212)
 *                                          Clear active bubble notifications when loading or generating a 3D preview.
 *                18-JAN-19   S Norman      Added a length check when clearing the compare Combo Control as there may be no compare docs.
 *                21-JAN-19   S Norman      Made it possible for supporting document to create 3d views. Added extra initialization code, MultiView can now just call this function when switching approvals.
 *                22-JAN-19   S Norman      Fixed an issue where a try catch would not work on IE or Edge. Added the on click event functionality initialisation to the  ThreeDViewInitialize method.
 *                24-JAN-19   S Norman      Fixed an issue where after generating a 3D preview, MultiView switching would cause the new 3D preview document to go missing.
 *                25-JAN-19   S Norman      Made the file names for the models and 3D previews shortened when they are too long for rendering them within the pop-up.
 *                29-JAN-19   S Norman      Removed whitespace from the thumbnail path.
 */

var g_oThreeDView = {};

(function () {
	"use strict";

	function ThreeDView() {

		// Instance setting flag sent from dragonfly.
		this.g_bCreateThreeDPreviews = false;

		// List of 3dViews for the current document.
		this.g_oThreeDViews = {};

		// List of 3DViews on the approval.
		this.g_oApprovalThreeDViews = {};

		// List of models for the current instance.
		this.g_oConsumerModelTemplates = {};
	}

   /*
	* Initializes the 3D View module by loading the current approvals 3D views and setting up on clicks for the 3D Tool.
	*/
	ThreeDView.prototype.ThreeDViewInitialize = function () {
		// Reset any objects, used when switching from multiview.js
		g_oThreeDView.g_oThreeDViews = {};
		g_oThreeDView.g_oApprovalThreeDViews = {};
		g_oThreeDView.g_oConsumerModelTemplates = {};

		// Load 3D views for the current approval for global usage, will populate g_oApprovalThreeDViews.
		var oComboControlDocuments = [];
		// If we have at least 1 compare document
		if (!(typeof g_oaComboControls[1] === "undefined")) {
			oComboControlDocuments = deepCopyArray(g_oaComboControls[1].documents);
		} else {
			oComboControlDocuments = deepCopyArray(g_oaComboControls[0].documents);
		}

		// Get a unique list of approval Ids
		var oApprovalIds = [];
		var oDocumentIds = [];
		for (var i = 0; i < oComboControlDocuments.length; i++) {
			oDocumentIds.push(oComboControlDocuments[i].greenlightDocumentId);
			var addId = true;
			for (var j = 0; j < oApprovalIds.length; j++) {
				if (oApprovalIds[j] === oComboControlDocuments[i].greenlightApprovalId) {
					addId = false;
					break;
				}
			}
			if (addId) { // Add only unique values
				oApprovalIds.push(oComboControlDocuments[i].greenlightApprovalId);
			}
		}
		// For each approval id get the 3D views and add to g_oApprovalThreeDViews.
		g_oThreeDView.GetApproval3DViews(oApprovalIds, oDocumentIds);

		// If instance setting is true and its not read only, show the ThreeD Viewer icon
		if (g_oThreeDView.g_bCreateThreeDPreviews) {
			var oControl = comboControl_GetControlById("approvalNameComboControl", false);
			$('#btnThreeDViewer').hide();

			// Ensure we have a valid document selected before continue. 
			// If the document is a pdf and the first page which we are on has a trim-box and not in read only mode
			if (oControl.documents.length > 0 && oControl.selectedDocumentIndex != -1 && oControl.documents[oControl.selectedDocumentIndex].document.documentType === eDocumentTypes.PDF && oControl.documents[oControl.selectedDocumentIndex].document.pages[0].trimBox) {
				$('#btnThreeDViewer').show();
			}

			// Populate model templates from instance
			g_oThreeDView.GetConsumerModelTemplates();
			$("#btnThreeDViewer").unbind("click");
			// btnThreeDViewer on click to show ThreeDViews and models for the current page.
			$("#btnThreeDViewer").click(function () {

				// If we have an active text highlight, prevent the drop down.
				if (g_oTextTools.g_bHighlightInProgress) {
					return;
				}

				// If the current document is a pdf.
				if (g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex].document.documentType === 1) {
					var iGreenlightDocumentPageIndex = (g_oaComboControls[0].selectedPageIndex === -1) ? 0 : g_oaComboControls[0].selectedPageIndex;
						g_oThreeDView.GetCurrentThreeDViews(
							g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex].greenlightApprovalId,
							g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex].document.documentId,
							g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex].document.pages[iGreenlightDocumentPageIndex].documentPageId,
							g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex].document.consumerId
					);
					g_oThreeDView.GetConsumerModelTemplates();
				}
				else {
					$('#tblModelImagePlaceHolders').html('<tbody></tbody>');
					$('#tblThreeDViewImagePlaceHolders').html('<tbody></tbody>');
				}

				if ($('#divModalOverlay').is(":visible")) {
					hidePopupWindow("divModalOverlay");
				}
				else {
					displayPopupWindow("divModalOverlay", 80, 75);
				}

			});
		}
		else {
			$('#btnThreeDViewer').hide();
		}
	};

   /*
	*  Renders the consumers models to the pop-up window and sets up the on clicks.
	*/
	ThreeDView.prototype.RenderModels = function (filter) {
		$('#tblModelImagePlaceHolders').html('<tbody></tbody>');
		if (!g_oThreeDView.g_oConsumerModelTemplates || !g_oThreeDView.g_oConsumerModelTemplates.length) {
			$('#divModelBodyModels').hide();
			return;
		}

		$('#divModelBodyModels').show();
		var szModelName = "";
		var html = "<tr>";
		// Generate models html
		for (var i = 0; i < g_oThreeDView.g_oConsumerModelTemplates.length; i++) {
			szModelName = g_oThreeDView.g_oConsumerModelTemplates[i].ModelFileName;			
			if (!filter || filter === "" || szModelName.toLowerCase().contains(filter)) {
				szModelName = szModelName.length > 15 ? szModelName.substring(0, 15) + "..." : szModelName;
				html += "<td style='display:inline-grid;' id='rowThreeDViewer_NewModel_" + i + "'>";
				html += "<img class='modelImagePlaceholder tooltip' src='" + g_oThreeDView.g_oConsumerModelTemplates[i].ModelThumbnailPath + "' title='" + g_oThreeDView.g_oConsumerModelTemplates[i].ModelFileName + "' />";
				html += "<span style='text-align: center; display: run-in;'>" + szModelName + "</span>";
				html += "</td>";
			}
		}
		html += "</tr>";
		$('#tblModelImagePlaceHolders').append(html);

		// Setup on clicks for models
		for (var j = 0; j < g_oThreeDView.g_oConsumerModelTemplates.length; j++) {
			szModelName = g_oThreeDView.g_oConsumerModelTemplates[j].ModelFileName;
			if (!filter || filter === "" || szModelName.toLowerCase().contains(filter)) {
				$("#rowThreeDViewer_NewModel_" + j).unbind("click");
				$("#rowThreeDViewer_NewModel_" + j).click(function () {
					hidePopupWindow("divModalOverlay");
					g_oProgressBar.addProgressBar(g_oThreeDView.c_szGeneratingPreview, true);
					g_oThreeDView.GetConsumerModelFile(this.id.split('_')[2]);
				});
			}
		}
	};

   /*
	*  Renders the 3D Previews to the pop-up window and sets up the on clicks.
	*/
	ThreeDView.prototype.RenderThreeDViews = function (filter) {
		$('#tblThreeDViewImagePlaceHolders').html('<tbody></tbody>');
		if (g_oThreeDView.g_oThreeDViews !== undefined && g_oThreeDView.g_oThreeDViews.length > 0) {
			$('#divModelBodyThreeDViews').show();
			var iDocumentId = -1;
			var szModelTemplateName = "";
			var szThreeDThumbnailPath = "";
			var html = "<tr>";
			// Generate ThreeDView HTML
			for (var i = 0; i < g_oThreeDView.g_oThreeDViews.length; i++) {
				szModelTemplateName = g_oThreeDView.g_oThreeDViews[i].ModelTemplateName;				
				if (!filter || filter === "" || szModelTemplateName.toLowerCase().contains(filter)) {
					for (var j = 0; j < g_oViewer.g_oaCompareDocuments.length; j++) {
						if (g_oViewer.g_oaCompareDocuments[j].document.Approval3DViewId === g_oThreeDView.g_oThreeDViews[i].Approval3DViewId) {
							iDocumentId = g_oViewer.g_oaCompareDocuments[j].greenlightDocumentId;
							break;
						}
					}
					szModelTemplateName = g_oThreeDView.g_oThreeDViews[i].ModelTemplateName.length > 15 ? g_oThreeDView.g_oThreeDViews[i].ModelTemplateName.substring(0, 15) + "..." : g_oThreeDView.g_oThreeDViews[i].ModelTemplateName;					
					szThreeDThumbnailPath = "/ViewImage/GetImage?threeDThumbnailPath=" + g_oThreeDView.g_oThreeDViews[i].ModelThumbnailPath + "&documentId=" + iDocumentId + "&pageNumber=0&sessionId=" + g_szSessionId + "&thumb=1&fileName=" + iDocumentId + "&fileExtension=jpg";
					html += "<td style='display:inline-grid;' id='rowThreeDViewer_Existing_" + i + "'>";
					html += "<img class='modelImagePlaceholder tooltip' src='" + szThreeDThumbnailPath + "' title='" + g_oThreeDView.g_oThreeDViews[i].ModelTemplateName + "'/>";
					html += "<span style='text-align: center; display: run-in;'>" + szModelTemplateName + "</span>";
					html += "</td>";
				}
			}

			html += "</tr>";
			//Append row
			$('#tblThreeDViewImagePlaceHolders > tbody:last-child').append(html);

			// Setup on clicks
			for (i = 0; i < g_oThreeDView.g_oThreeDViews.length; i++) {
				szModelTemplateName = g_oThreeDView.g_oThreeDViews[i].ModelTemplateName;
				if (!filter || filter === "" || szModelTemplateName.toLowerCase().contains(filter)) {
					$("#rowThreeDViewer_Existing_" + i).unbind("click");
					$("#rowThreeDViewer_Existing_" + i).click(function () {
						var oThreeDViewIndex = this.id.split('_')[2];
						var iDocumentId = $.findfirst(g_oaComboControls[0].documents, function (x) {
												return x.document.Approval3DViewId === g_oThreeDView.g_oThreeDViews[oThreeDViewIndex].Approval3DViewId;
											}).greenlightDocumentId;
						var iDocumentIndex = 0;

						for (var i = 0; i < g_oaComboControls[0].documents.length; i++) {
							if (g_oaComboControls[0].documents[i].greenlightDocumentId === iDocumentId) {
								iDocumentIndex = i;
								break;
							}
						}
						// Change selected item.
						comboControl_SelectOption(0, iDocumentIndex, -1, true);
						hidePopupWindow("divModalOverlay");
					});
				}
			}
		}
		else {
			$('#divModelBodyThreeDViews').hide();
		}
	};

   /*
	*  - - - A J A X  R E Q U E S T S- - -
	*/

   /*
	*  Called when switching to a 3D preview to load the parents annotations onto the 3D artwork.
	*/
	ThreeDView.prototype.ToggleThreeDView = function (ParentAnnotations, ParentDocument, ParentDocumentPageId, DocumentId, ApprovalId) {
		var oDocument = $.findfirst(g_oViewer.g_oaCompareDocuments, function (x) {
							return x.greenlightDocumentId === DocumentId;
						});
		var oThreeDView = g_oThreeDView.GetThreeDView(oDocument.document.Approval3DViewId);
		var szPrimaryArtworkTexture = GetFileNameWithoutExtension(oThreeDView.ModelTemplatePrimaryArtworkFileName);
		var szModelTemplatePath = oThreeDView.ModelTemplatePath + '\\' + oThreeDView.ModelTemplateName;
		var oJSON = {
			SessionId: g_szSessionId,
			ParentAnnotations: ParentAnnotations,
			ParentDocument: ParentDocument,
			ParentDocumentPageId: ParentDocumentPageId,
			DocumentId: DocumentId,
			ApprovalId: ApprovalId,
			ModelPrimaryTextureName: szPrimaryArtworkTexture,
			ModelPath: szModelTemplatePath
		};
		$.ajax({
			type: "POST",
			url: "api/Greenlight3dView/ToggleThreeDView",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function (response) {
				g_oThreeDView.ToggleThreeDView_CH(response, ApprovalId);
			},
			failure: function (response) {
				g_oProgressBar.removeProgressBar();
				g_oGreenlightMessages.displayErrorBubble(g_oThreeDView.c_szFailedToLoadParentAnnotations);
			},
			error: function (response) {
				// Remove the progress bar.
				g_oProgressBar.removeProgressBar();
				g_oGreenlightMessages.displayErrorBubble(g_oThreeDView.c_szFailedToLoadParentAnnotations);
			}
		});
	};

   /*
	*  Called when adding an annotation to a 3D preview. The annotations gets added to the parent as a post-it.
	*/
	ThreeDView.prototype.AddThreeDViewAnnotation = function (ApprovalId, ApprovalUserId, SessionId, ThirdPartyMemberId, CompareDocumentId, NewAnnotation, ParentDocument, ParentDocumentPageId, ModelTemplatePath, PrimaryArtWorkTexture, iThreeDViewdocumentId, _oldId) {
		// Build up the annotation string.
		var oJSON = {
			SessionId: SessionId,
			ApprovalId: ApprovalId,
			ApprovalUserId: ApprovalUserId,
			ThirdPartyMemberId: ThirdPartyMemberId,
			NewAnnotation: NewAnnotation,
			ParentDocument: ParentDocument,
			ParentDocumentPageId: ParentDocumentPageId,
			ModelPath: ModelTemplatePath,
			ModelPrimaryTextureName: PrimaryArtWorkTexture,
			CompareDocumentId: CompareDocumentId,
			ThreeDViewDocumentId: iThreeDViewdocumentId
		};

		$.ajax({
			type: "POST",
			url: "api/Greenlight3dView/AddThreeDViewAnnotation",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function (response) {
				g_oThreeDView.AddThreeDViewAnnotation_CH(response, _oldId);
			},
			failure: function (response) {
				g_oGreenlightMessages.displayErrorBubble(g_oAnnotations.c_szAnnotationFailedtoSave);
			},
			error: function (response) {
				g_oGreenlightMessages.displayErrorBubble(g_oAnnotations.c_szAnnotationFailedtoSave);
			}
		});
	};

   /*
	*  Gets the 3D views for an approval.
	*/
	ThreeDView.prototype.GetApproval3DViews = function (ApprovalIds, DocumentIds) {
		var oJSON = {
			SessionId: g_szSessionId,
			ApprovalIds: ApprovalIds,
			DocumentIds: DocumentIds
		};
		$.ajax({
			type: "POST",
			url: "api/Greenlight3dView/GetApproval3DViews",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function (response) {
				g_oThreeDView.GetApproval3DViews_CH(response.Contents);
			},
			failure: function (response) {
				g_oGreenlightMessages.displayErrorBubble(g_oThreeDView.c_szFailedToGetPreviewsCurrentApproval);
			},
			error: function (response) {
				g_oGreenlightMessages.displayErrorBubble(g_oThreeDView.c_szFailedToGetPreviewsCurrentApproval);
			}
		});
	};

   /*
	*  Gets the 3D views for a document.
	*/
	ThreeDView.prototype.GetCurrentThreeDViews = function (approvalId, parentDocumentId, parentDocumentPageId, consumerId) {
		var oJSON = {
			ApprovalId: approvalId,
			ParentDocumentId: parentDocumentId,
			ParentDocumentPageId: parentDocumentPageId,
			ConsumerId: consumerId,
			SessionId: g_szSessionId
		};
		$.ajax({
			type: "POST",
			url: "api/Greenlight3dView/GetCurrentThreeDViews",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function (response) {
				g_oThreeDView.GetCurrentThreeDViews_CH(response.Contents);
			},
			failure: function (response) {
				g_oGreenlightMessages.displayErrorBubble(g_oThreeDView.c_szFailedToGetPreviewsCurrentDocument);
			},
			error: function (response) {
				g_oGreenlightMessages.displayErrorBubble(g_oThreeDView.c_szFailedToGetPreviewsCurrentDocument);
			}
		});
	};

   /*
	*  Gets the consumer model template metadata from the consumer.
	*/
	ThreeDView.prototype.GetConsumerModelTemplates = function () {
		var oJSON = {
			SessionId: g_szSessionId
		};

		$.ajax({
			type: "POST",
			url: "api/Greenlight3dView/GetConsumerModelTemplates",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function (response) {
				g_oThreeDView.GetConsumerModelTemplates_CH(response.Contents);
			},
			failure: function (response) {
				g_oGreenlightMessages.displayErrorBubble(g_oThreeDView.c_szFailedToGetModelTemplates);
			},
			error: function (response) {
				g_oGreenlightMessages.displayErrorBubble(g_oThreeDView.c_szFailedToGetModelTemplates);
			}
		});

	};

   /*
	*  Gets a 3D model file from the consumer and puts it in the cache.
	*/
	ThreeDView.prototype.GetConsumerModelFile = function (Index) {
		var oJSON = {
			SessionId: g_szSessionId,
			AssetId: g_oThreeDView.g_oConsumerModelTemplates[Index].AssetId,
			ThreeDTemplateId: g_oThreeDView.g_oConsumerModelTemplates[Index].ThreeDTemplateId,
			ModelFilePath: g_oThreeDView.g_oConsumerModelTemplates[Index].ModelFilePath,
			ModelFileMimeType: g_oThreeDView.g_oConsumerModelTemplates[Index].ModelFileMimeType,
			ModelFileName: g_oThreeDView.g_oConsumerModelTemplates[Index].ModelFileName,
			ModelPrimaryArtworkFileName: g_oThreeDView.g_oConsumerModelTemplates[Index].ModelPrimaryArtworkFileName,
			GreenlightDocumentId: g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex].greenlightDocumentId
		};

		$.ajax({
			type: "POST",
			url: "api/Greenlight3dView/GetConsumerModelFile",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function (response) {
				g_oThreeDView.GetConsumerModelFile_CH(response.Contents);
			},
			failure: function (response) {
				// Remove the progress bar.
				g_oProgressBar.removeProgressBar();
				g_oGreenlightMessages.displayErrorBubble(g_oThreeDView.c_szFailedToDownloadModelFile);
			},
			error: function (response) {
				// Remove the progress bar.
				g_oProgressBar.removeProgressBar();
				g_oGreenlightMessages.displayErrorBubble(g_oThreeDView.c_szFailedToDownloadModelFile);
			}
		});
	};

   /*
	*  Manipulates the cached 3D model template and replaces the primary artwork texture with the trim of a pdf document.
	*/
	ThreeDView.prototype.GenerateThreeDView = function (ConsumerId, ApprovalId, ParentDocumentId, ParentDocumentPageId, DocumentPageNumber, ModelTemplatePath, PrimaryArtworkImage, ImageRequest) {
		if (g_oaComboControls.length > 1) {
			// Deactivate compare mode if we are in compare mode.
			comboControl_ClearOption(1, true);
		}

		var oJSON = {
			ConsumerId: ConsumerId,
			ApprovalId: ApprovalId,
			ParentDocumentId: ParentDocumentId,
			ParentDocumentPageId: ParentDocumentPageId,
			DocumentPageNumber: DocumentPageNumber,
			ModelPath: ModelTemplatePath,
			PrimaryArtworkImage: PrimaryArtworkImage,
			ImageRequest: ImageRequest
		};

		$.ajax({
			type: "POST",
			url: "api/Greenlight3dView/GenerateThreeDView",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function (response) {
				// If successful.
				if (response.Success) {
					g_oThreeDView.GenerateThreeDView_CH(response.Contents);
				}
				// If unsuccessful.
				else {
					// Remove the progress bar.
					g_oProgressBar.removeProgressBar();
					g_oGreenlightMessages.displayErrorBubble(g_oThreeDView.c_szFailedToGeneratePreview);
				}
			},
			failure: function (response) {
				// Remove the progress bar.
				g_oProgressBar.removeProgressBar();
				g_oGreenlightMessages.displayErrorBubble(g_oThreeDView.c_szFailedToGeneratePreview);
			},
			error: function (response) {
				// Remove the progress bar.
				g_oProgressBar.removeProgressBar();
				g_oGreenlightMessages.displayErrorBubble(g_oThreeDView.c_szFailedToGeneratePreview);
			}
		});

	};

   /*
	*  - - - C A L L B A C K  H A N D L E R S - - -
	*/

   /*
	*  Callback when adding a annotation to a 3D preview, sets up and renders the annotation.
	*/
	ThreeDView.prototype.AddThreeDViewAnnotation_CH = function (response, _oldId) {
		// Display the success bubble.
		g_oGreenlightMessages.displaySuccessBubble(g_oAnnotations.c_szAnnotationSavedSuccessfully);

		// Determine the canvas to use.
		var oAnnotationCanvas = g_oViewer.getCanvas("AnnotationViewer");
		var oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(oAnnotationCanvas.g_szCanvasId);

		// Splice the old ID out the array, it will be re-rendered later.
		if (g_oAnnotations.g_iApprovalType === eDocumentTypes.ThreeD) {
			for (var i = (oArtworkCanvas.g_oScene.children.length - 1); i > -1; i--) {
				// Remove both the Annotation object & the Annotation Number from the 3D scene array.
				if (oArtworkCanvas.g_oScene.children[i].Id == _oldId || oArtworkCanvas.g_oScene.children[i].Id === "annNo_" + _oldId) {
					oArtworkCanvas.g_oScene.children.splice(i, 1);
				}
			}
		}

		g_oAnnotations.g_oAnnotationsMade = [];

		var responseObj = JSON.parse(response.Contents);

		// Setup annotations sending in the collada texture.
		g_oAnnotations.setupAnnotations(responseObj.Annotations, oArtworkCanvas, oAnnotationCanvas, responseObj.ColladaMaterialName);

		// If the annotation save was called on the main annotation only
		$(".annotation").remove();

		oAnnotationCanvas.redraw(false);

		// Recalculate the page annotation numbers.
		g_oAnnotations.renderPageAnnotationNumbers();

		// Attempt to send annotations to signalR.
		try {
			g_oAnnotations.g_oAnnotationHub.server.send(g_oAnnotations.g_iApprovalId, g_oUserDetails.EmailAddress);
		} catch(ex) {}

		// Rebind the draw functions once annotation saves.
		// Use setTimeout to make sure we ONLY rebind the canvas functions,
		// once they have finished, as they will execute twice!.
		var oTimer = setTimeout(function () {
			g_oAnnotations.currentTimeoutListRemove(oTimer);

			// Only reset the annotation mouse events if there are no other actions in progress (i.e. Pan or Marquee Zoom).
			if (!g_oAnnotations.g_bNonAnnotationActionInProgress) {
				g_oAnnotations.initiateAnnotationDraw(0, oArtworkCanvas, oAnnotationCanvas);
			}
		}, 1000);

		g_oAnnotations.currentTimeoutListAdd(oTimer);
	};

   /*
	*  Callback when switching to a 3D preview, sets up the annotations sending in the collada texture.
	*/
	ThreeDView.prototype.ToggleThreeDView_CH = function (response, iApprovalId) {
		// Close any active bubbles
		for (var i = 0; i < g_oActiveBubbles.length; i++) {
			g_oGreenlightMessages.closeBubble(g_oActiveBubbles[i].id, true, true);
		}
		var responseObj = JSON.parse(response.Contents);

		// Determine the canvas to used for rendering based on the annotation toggle.
		var oAnnotationCanvas = g_oViewer.getCanvas(g_oCompare.getAnnotationCanvasId());
		var oArtworkCanvas = g_oViewer.getLinkedArtworkCanvas(oAnnotationCanvas.g_szCanvasId);

		var oNewThreeDAnnotations = responseObj.Annotations;
		var szColladaMaterialTexture = responseObj.ColladaMaterialName;

		g_oAnnotations.g_szColladaTexture = szColladaMaterialTexture;

		var oControl = comboControl_GetControlById("approvalNameComboControl", false);
		// Ensure these annotations are in sync with the current document
		if (oNewThreeDAnnotations.length > 0) {
			// Refresh the g_oAnnotations object with the new details.
			g_oAnnotations.g_oAnnotationViewer = g_oViewer.g_oAnnotationViewer;
			g_oAnnotations.g_oArtworkViewer = g_oViewer.g_oArtworkViewer;
			g_oAnnotations.g_iApprovalType = g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex].document.documentType;
			g_oAnnotations.g_iApprovalId = iApprovalId;

			// Clear out the annotations.
			g_oAnnotations.g_oAnnotationsMade = [];

			// Setup the annotations.
			g_oAnnotations.setupAnnotations(oNewThreeDAnnotations, oArtworkCanvas, oAnnotationCanvas, szColladaMaterialTexture);

			// Clear 3D annotation mesh.
			g_oAnnotations.clearMesh(g_oCompare.g_oArtworkViewer, g_oCompare.g_oAnnotationViewer);
			g_oAnnotations.clearMesh(g_oCompare.g_oCompareViewer, g_oCompare.g_oCompareAnnotationViewer);

			// Remove the progress bar.
			g_oProgressBar.removeProgressBar();
		}
	};

   /*
	*  Callback when getting the 3D views for an approval, populates g_oApprovalThreeDViews.
	*/
	ThreeDView.prototype.GetApproval3DViews_CH = function (response) {

		// Extract the response and 3D information.
		var oResponse = $.parseJSON(response);
		var oThreeDViews = oResponse.ThreeDViews;
		var oThreeDViewDocuments = oResponse.Documents;

		// If we do not have anything in the 3D views.
		if (!(g_oThreeDView.g_oApprovalThreeDViews.length > 0)) {

			// Populate Approval Three D View global.
			g_oThreeDView.g_oApprovalThreeDViews = oThreeDViews;
		}
		// If we already have 3D views.
		else {

			// If it doesn't exist in the list then add it.
			for (var i = 0; i < oThreeDViews.length; i++) {

				// Try to get the 3D view.
				var oThreeDView = g_oThreeDView.GetThreeDView(oThreeDViews[i].Approval3DViewId);

				// If we could not get the 3D view.
				if (!oThreeDView) {

					// Add it to the list.
					g_oThreeDView.g_oApprovalThreeDViews.push(oThreeDViews[i]);

					// Get the 3D view.
					oThreeDView = g_oThreeDView.GetThreeDView(oThreeDViews[i].Approval3DViewId);
				}

				// Get the 3D view document.
				var oThreeDViewDocument = $.findfirst(oThreeDViewDocuments, function (x) {
					return x.Approval3DViewId === oThreeDView.Approval3DViewId;
				});

				// Outline the document.
				var oDocument = {
					document: oThreeDViewDocument,
					documentName: $.findfirst(g_oViewer.g_oaCompareDocuments, function (x) {
						return x.greenlightDocumentId === oThreeDView.ParentDocumentId;
					}).documentName + " " + oThreeDViewDocument.documentName,
					greenlightApprovalId: oThreeDView.ApprovalId,
					greenlightDocumentId: oThreeDViewDocument.documentId
				};

				// Find the added document.
				var oDocumentAdded = $.findfirst(g_oaComboControls[0].documents, function (x) {
					return x.greenlightDocumentId === oThreeDViewDocument.documentId;
				});

				// If successful.
				if (typeof oDocumentAdded === "undefined" || oDocumentAdded.length === 0) {

					// Load 3D View Document to correct position of document arrays.
					var iParentDocumentId = $.findfirst(g_oViewer.g_oaCompareDocuments, function (x) {
						return x.greenlightDocumentId === oThreeDView.ParentDocumentId;
					}).greenlightDocumentId;

					// Add to combo control 0 as its removed when switching with multi-view.
					g_oThreeDView.AddToDocumentList(g_oaComboControls[0].documents, oDocument, iParentDocumentId);
					g_oThreeDView.AddToDocumentList(g_oaComboControls[1].documents, oDocument, iParentDocumentId);
					g_oThreeDView.AddToDocumentList(g_oViewer.g_oaCompareDocuments, oDocument, iParentDocumentId);
				}
			}
		}
	};

   /*
	*  Callback when getting consumer model templates, if no templates exist hides the Three D module icon.
	*/
	ThreeDView.prototype.GetConsumerModelTemplates_CH = function (response) {
		
		// Check we have a valid response and parse this to our consumer templates.
		try {
			if (response !== "") {
				g_oThreeDView.g_oConsumerModelTemplates = $.parseJSON(response);
			}
		}
		catch (e) {
			g_oGreenlightMessages.displayErrorBubble(g_oThreeDView.c_szFailedToGetModelTemplates);
			g_oThreeDView.g_oConsumerModelTemplates = {};
		}

		// If we have valid consumer templates.
		if (g_oThreeDView.g_oConsumerModelTemplates[0] && g_oThreeDView.g_oConsumerModelTemplates.length > 0) {

			// Render the models.
			g_oThreeDView.RenderModels();
		}
		// If we do not have valid consumer templates.
		else {

			// Reset the object and hide the button.
			g_oThreeDView.g_oConsumerModelTemplates = {};
			$('#btnThreeDViewer').hide();
		}
	};

   /*
	*  Callback when getting a consumer model file, if successful calls generate 3D view to generate the new 3D preview.
	*/
	ThreeDView.prototype.GetConsumerModelFile_CH = function (response) {
		var oTemplateModelData = $.parseJSON(response);
		var iGreenlightDocumentPageIndex = (g_oaComboControls[0].selectedPageIndex === -1) ? 0 : g_oaComboControls[0].selectedPageIndex;
		var oSelectedPage = g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex].document.pages[iGreenlightDocumentPageIndex];

		// Generate new 3DView
		this.GenerateThreeDView(
			g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex].document.consumerId,
			g_oaComboControls[0].documents[g_oaComboControls[0].selectedDocumentIndex].greenlightApprovalId,
			oTemplateModelData.GreenlightDocumentId,
			oSelectedPage.documentPageId,
			oSelectedPage.documentPageNumber,
			oTemplateModelData.ModelFilePath,
			oTemplateModelData.ModelPrimaryArtworkFileName,
			g_oViewer.g_oArtworkViewer.getImageRequest(true)
		);

	};

   /*
	*  Callback when generating a 3D preview, sets up the combo controls, adding the new 3D document
	*/
	ThreeDView.prototype.GenerateThreeDView_CH = function (response) {
		if (response !== "") {
			var oNewThreeDViewResponse = $.parseJSON(response);
			var oDocument = {
				document: oNewThreeDViewResponse.ThreeDViewDocument,
				documentName: $.findfirst(g_oViewer.g_oaCompareDocuments, function (x) {
									return x.greenlightDocumentId === oNewThreeDViewResponse.ThreeDView[0].ParentDocumentId;
								}).documentName + " " + oNewThreeDViewResponse.ThreeDViewDocument.documentName,
				greenlightApprovalId: oNewThreeDViewResponse.ThreeDView[0].ApprovalId,
				greenlightDocumentId: oNewThreeDViewResponse.ThreeDViewDocument.documentId
			};
			// Load 3D View Document to correct position of document arrays.
			var iParentDocumentId = $.findfirst(g_oViewer.g_oaCompareDocuments, function (x) {
										return x.greenlightDocumentId === oNewThreeDViewResponse.ThreeDView[0].ParentDocumentId;
									}).greenlightDocumentId;
			//Add to compare list
			g_oThreeDView.AddToDocumentList(g_oViewer.g_oaCompareDocuments, oDocument, iParentDocumentId);

			// Add to combo control 0, Return the parent index for this combo control as we need it for selecting the option.
			var iParentIndex = g_oThreeDView.AddToDocumentList(g_oaComboControls[0].documents, oDocument, iParentDocumentId);

			// If compare documents exist
			if (typeof g_oaComboControls[1] !== "undefined") {
				// Add to combo control 1 (compare documents)
				g_oThreeDView.AddToDocumentList(g_oaComboControls[1].documents, oDocument, iParentDocumentId);
			} else {
				// Reshow the tools if hidden.
				$("#tblCompareTools").show();

				// Create the compare document combo control.
				comboControl_CreateNewControl("approvalCompareComboControl", "divCompareName", g_oCompare.c_szCompareDocument, g_oaComboControls[0].documents, false, "g_oCompare.compareDocChangeEvent();", g_oCompare.c_szSelectCompareDocument, g_oCompare.c_szDeactivateCompareDocument, 0);

				// Setup the page select option.
				g_oApprovalFiles.Setup(comboControl_GetControlById("approvalCompareComboControl", true));
			}
			// Add threeDView to threeDView list
			if (g_oThreeDView.g_oApprovalThreeDViews.length > 0) {
				g_oThreeDView.g_oApprovalThreeDViews.push(oNewThreeDViewResponse.ThreeDView[0]);
			}
			else {
				g_oThreeDView.g_oApprovalThreeDViews = oNewThreeDViewResponse.ThreeDView;
			}
			if (g_oThreeDView.g_oThreeDViews.length > 0) {
				g_oThreeDView.g_oThreeDViews.push(oNewThreeDViewResponse.ThreeDView[0]);
			}
			else {
				g_oThreeDView.g_oThreeDViews = oNewThreeDViewResponse.ThreeDView;
			}
		}
		// validate that we have an index.
		if (iParentIndex != undefined) {
			comboControl_SelectOption(0, iParentIndex + 1, -1, true);
		}
		else {
			g_oGreenlightMessages.displayErrorBubble(g_oViewer.c_szInvalidDocument);
		}
	};

   /*
	*  Callback when getting three d views for the current document, calls the render function after populating list.
	*/
	ThreeDView.prototype.GetCurrentThreeDViews_CH = function (response) {
		if (response !== "") {
			g_oThreeDView.g_oThreeDViews = $.parseJSON(response);
			// filter out everything we cannot render
			g_oThreeDView.g_oThreeDViews = g_oThreeDView.g_oThreeDViews.filter(function (x) {
				return g_oaComboControls[0].documents.map(function (x) {
					return x.document.Approval3DViewId;
				}).some(function (y) {
					return y === x.Approval3DViewId;
				});
			});
		}
		else {
			g_oThreeDView.g_oThreeDViews = {};
		}
		// Hide the models if we have 3D Previews
		if (g_oThreeDView.g_oThreeDViews[0]) {

			var szThreeDControlRightArrow = g_oSettings.c_iSkinType === 0 ? "img/Arrow_Right_White_16.png" : "img/Arrow_Right_16.png";

			// Hide models
			$('#imgExpandModels').attr('src', szThreeDControlRightArrow);
			$('#tblModelImagePlaceHolders').hide();

		}
		g_oThreeDView.RenderThreeDViews();
	};

   /*
	*  - - - F U N C T I O N S - - -
	*/

   /*
	*  Takes the 2D point, run through the geometries and return a 3D world vector if a match is found.
	*/
	ThreeDView.prototype.TraversePolygonsForGeometries = function (node, uvx, uvy, threeDdocumentId, szColladaModelTexture) {
		if (node.geometry) {
			// Return a list of possible polygons that have the annotation within them.
			// The returned objects will have the x,y,z barycentric coordinates of the point inside the respective polygon
			var baryData = this.ObtainBaryDataFromVertices(uvx, uvy, node.geometry.faceVertexUvs);
			for (var j = 0; j < baryData.length; j++) {
				// Check to ensure that the material name matches the selected texture. Otherwise we get UV points on other materials which don't represent the artwork = bad.
				if (node.geometry.faces[baryData[j][0]].daeMaterial === szColladaModelTexture) {
					// We have a proper match. Get the points for the relevant vertices.
					var vertexa = node.geometry.vertices[node.geometry.faces[baryData[j][0]].a];
					var vertexb = node.geometry.vertices[node.geometry.faces[baryData[j][0]].b];
					var vertexc = node.geometry.vertices[node.geometry.faces[baryData[j][0]].c];
					// We know the percentage along each vertex. Multiply out to triangulate the position.
					var worldX = vertexa.x * baryData[j][1] + vertexb.x * baryData[j][2] + vertexc.x * baryData[j][3];
					var worldY = vertexa.y * baryData[j][1] + vertexb.y * baryData[j][2] + vertexc.y * baryData[j][3];
					var worldZ = vertexa.z * baryData[j][1] + vertexb.z * baryData[j][2] + vertexc.z * baryData[j][3];
					var vector = new THREE.Vector3(worldX, worldY, worldZ);
					// Convert to world vs local space.
					var worldVector = vector.applyMatrix4(node.matrixWorld);
					return worldVector;
				}
			}
		}
		// Recurse through any child nodes.
		if (node.children) {
			for (var i = 0; i < node.children.length; i++) {
				var worldVectorPoint = g_oThreeDView.TraversePolygonsForGeometries(node.children[i], uvx, uvy, threeDdocumentId, szColladaModelTexture);
				if (worldVectorPoint) {
					return worldVectorPoint;
				}
			}
		}
	};

   /*
	*  Obtains binary data from vertices.
	*/
	ThreeDView.prototype.ObtainBaryDataFromVertices = function (uvX, uvY, faceVertexUvArray) {
		var point = {};
		point.x = uvX;
		point.y = uvY;
		var results = [];
		for (var i = 0; i < faceVertexUvArray[0].length; i++) {
			var result = g_oThreeDView.PtInTriangle(point, faceVertexUvArray[0][i][0], faceVertexUvArray[0][i][1], faceVertexUvArray[0][i][2]);
			if (result.length) {
				results.push([i, result[0], result[1], result[2]]);
			}
		}
		return results;
	};

   /*
	*  Gets a single point in the centre of a triangle.
	*/
	ThreeDView.prototype.PtInTriangle = function(p, p0, p1, p2) {
		var x0 = p.x;
		var y0 = p.y;
		var x1 = p0.x;
		var y1 = p0.y;
		var x2 = p1.x;
		var y2 = p1.y;
		var x3 = p2.x;
		var y3 = p2.y;

		var b0 = (x2 - x1) * (y3 - y1) - (x3 - x1) * (y2 - y1);
		var b1 = ((x2 - x0) * (y3 - y0) - (x3 - x0) * (y2 - y0)) / b0;
		var b2 = ((x3 - x0) * (y1 - y0) - (x1 - x0) * (y3 - y0)) / b0;
		var b3 = ((x1 - x0) * (y2 - y0) - (x2 - x0) * (y1 - y0)) / b0;

		if (b1 > 0 && b2 > 0 && b3 > 0) {
			return [b1, b2, b3];
		} else {
			return [];
		}
	};

   /*
	* Adds a ThreeDView document to a document list. Returns the parents index.
	*/
	ThreeDView.prototype.AddToDocumentList = function (oDocumentList, oDocument, iParentDocumentId) {
		var iParentIndex = 0;
		// Find the parents index
		for (var i = 0; i < oDocumentList.length; i++) {
			if (oDocumentList[i].greenlightDocumentId === iParentDocumentId) {
				iParentIndex = i;
				break;
			}
		}
		// If parent is last in list we can push
		if (iParentIndex === oDocumentList.length - 1) {
			// Add document to end.
			oDocumentList.push(oDocument);
		}
		else {
			// Insert Document after parent.
			oDocumentList.splice(iParentIndex + 1, 0, oDocument);
		}
		return iParentIndex;
	};

   /*
	* Returns a ThreeDView object given the ApprovalThreeDViewId.
	*/
	ThreeDView.prototype.GetThreeDView = function (ApprovalThreeDViewId) {
		return $.findfirst(g_oThreeDView.g_oApprovalThreeDViews, function (x) {
			return x.Approval3DViewId === ApprovalThreeDViewId;
		});
	};

   /*
	* Add the ThreeDView object to the window.
	*/
	window.ThreeDView = ThreeDView;

}());

